import Axios from '../axios-instance';

const PurchaseOrderExclusionCertificatesAPI = {
  getDetail: (code) => {
    return Axios.post(`/ExcludedCertificatePurchaseOrders/Getdetail/${code}`).then(({ data }) => data);
  },

  insertExcludedCertificate: body => {
    return Axios.post(`/ExcludedCertificatePurchaseOrders/insert`, body).then(({ data }) => data);
  },

  deleteExcludedCertificate: body => {
    return Axios.post(`/ExcludedCertificatePurchaseOrders/delete`, body).then(({ data }) => data);
  },

  getDataGrid: body => {
    return Axios.post(`/ExcludedCertificatePurchaseOrders/getDataGrid`, body ).then(({ data }) => data);
  },
};


export default PurchaseOrderExclusionCertificatesAPI;